module.exports = __webpack_public_path__ + "static/media/tuer_btn_richtig.63b07313.jpg";